import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';

export const useAgentSeatLimit = () => {
  const { currentAccount } = useAccount();
  const { t } = useI18n();
  const isBillingEnabled = useMapGetter('globalConfig/isBillingEnabled');

  const agentLimits = computed(() => currentAccount.value?.limits?.agents || null);

  const billing = computed(() => currentAccount.value?.billing || {});

  const isAtSeatLimit = computed(() => {
    const limits = agentLimits.value;
    if (!limits?.allowed) return false;

    return limits.consumed >= limits.allowed;
  });

  const showSeatLimitWarning = computed(
    () => isBillingEnabled.value && isAtSeatLimit.value
  );

  const seatLimitMessage = computed(() => {
    if (!showSeatLimitWarning.value) return '';

    if (billing.value.on_trial) {
      return t('BILLING_SETTINGS.TRIAL.CAP_AGENTS', {
        count: agentLimits.value.allowed,
      });
    }

    return t('BILLING_SETTINGS.PLAN_LIMITS.AGENTS', {
      plan: billing.value.plan_name || t('BILLING_SETTINGS.PLANS.NO_PLAN'),
      count: agentLimits.value.allowed,
    });
  });

  return {
    agentLimits,
    isAtSeatLimit,
    showSeatLimitWarning,
    seatLimitMessage,
  };
};
